export const documentTypeOptions = [
  { enum: 1, value: "Assign", label: "مهروامضاء" },
  { enum: 0, value: "None", label: "بدون شناسه" },
]
